"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var EMAIL_MAP = exports.EMAIL_MAP = {
    1: "experience@gadventures.com",
    3: "apis@justyou.co.uk",
    4: "apis@travelsphere.co.uk",
    5: "experience@gadventures.com",
    13: "info@trutravels.com",
    16: "smithsonianjourneys@gadventures.com"
};

var AGENCY_EMAIL_MAP = exports.AGENCY_EMAIL_MAP = {
    1717526: "natgeojourneys@gadventures.com"
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/mappings/emails.js
// module id = 1425
// module chunks = 0